"use client";

import { User } from "@entities/user";
import { LayoutSetting } from "@shared/cms";
import { SharedConfig } from "@shared/lib/config";
import { User as NacoUser } from "@shared/naco";
import { createContext, useContext } from "react";

type ClientAppProviderType = {
  layoutSetting: LayoutSetting;
  config: SharedConfig;
  accessToken?: string | null;
  nacoUser?: NacoUser | null;
  user?: User | null;
};

export const ClientAppProviderContext = createContext<ClientAppProviderType | null>(null);

export function ClientAppProvider({
  children,
  layoutSetting,
  accessToken,
  nacoUser,
  user,
  config,
}: {
  children: React.ReactNode;
  layoutSetting: any;
  accessToken?: string | null;
  nacoUser?: NacoUser | null;
  user?: User | null;
  config: any;
}) {
  return (
    <ClientAppProviderContext.Provider
      value={{
        layoutSetting,
        config,
        accessToken,
        nacoUser,
        user,
      }}
    >
      {children}
    </ClientAppProviderContext.Provider>
  );
}

export function useClientConfig() {
  return useContext(ClientAppProviderContext);
}
